<!-- <p>resetpassword works!</p>
<div class="card-header">
    Keeping when refresh page
   <view-code name="keeping-when-refresh"></view-code>
  </div>
  <div class="card-body">
    <countdown  [config]="config" (event)="handleEvent($event)"></countdown>
  </div> -->
<!-- event Head -->
<div
  class="event-header"
  style="background-image: url(assets/image/Group-1896.png)"
>
  <div class="event-heading">
    <div class="event-head">
    </div>
  </div>
</div>

<!-- checkpassword -->
<!-- <div class="container">
  <div class="forgotpasswords">
    <form #userlogin="ngForm" (ngSubmit)="OnUserGet(userlogin.value)">
      <input type="text" name="username" id="" [ngModel] />
      <input type="submit" value="submit" />
    </form>
  </div>
</div> -->
<!-- checkpassword -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>
<div class="container resetpassword">
  <div class="alert alert-warning alert-dismissible fade show alert-position" role="alert" *ngIf="pusherror">
    {{errormessage}}
    <button type="button" class="close"  (click)="closenotif()">
      <span >&times;</span>
    </button>
  </div>
	<div class="row">
		<div class="col-md-4 offset-md-4">
      <ng-template [ngIf]="getuserdata">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3><i class="fa fa-lock fa-4x"></i></h3>
                  <h2 class="text-center">Forgot Password?</h2>
                  <p>You can reset your password here.</p>
                  <div class="panel-body">
    
                    <form id="register-form" role="form" autocomplete="off" class="form" #userlogin="ngForm" (ngSubmit)="OnUserGet(userlogin.value)">
    
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                          <input id="email" name="username" placeholder="Email" class="form-control"  type="email"  [ngModel]>
                        </div>
                      </div>
                      <div class="form-group">
                        <input name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Reset Password" type="submit">
                        
                      </div>
                    </form>
    
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="generateOTP">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <!-- <h3><i class="fa fa-lock fa-4x"></i></h3> -->
                  <h2 class="text-center">One Time Password Verification</h2>
                  <p>Check Your Email inbox/spam/junk folders.</p>
                  <div class="panel-body">
    
                    <form id="register-form" role="form" autocomplete="off" class="form" #GetOtpdata="ngForm" (ngSubmit)="getUserOtp(GetOtpdata.value)">
    
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                          <input  name="otp" placeholder="Enter Verification Code" class="form-control"  type="text"  [ngModel]>
                        </div>
                      </div>
                      <p>{{timeLeft}} Seconds Left....</p> 

                      <div class="form-group">
                        <ng-template [if]>

                        </ng-template>

                        <div *ngIf="requesttoken; else elseBlock"> <input name="button" (click)="getusertoken()" class="btn btn-lg btn-primary btn-block" value="Resend OTP"  > </div>
<ng-template #elseBlock>  <input name="submit" class="btn btn-lg btn-primary btn-block" id="tokenbtn" value="submit" type="submit" ></ng-template>


                      
                        <!-- <countdown  [config]="config" (event)="handleEvent($event)"></countdown> -->
                      </div>
                    </form>
    
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template [ngIf]="resetpasswordForm">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3><i class="fa fa-lock fa-4x"></i></h3>
                  <h2 class="text-center">Set New Password</h2>
                  <div class="panel-body">
    
                    <form id="register-form" role="form" autocomplete="off" class="form" #changePassword="ngForm" (ngSubmit)="changepassword(changePassword.value)">
    
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                        
                        </div>
                        <div class="form-group">
                          <input  name="password" placeholder="password" class="form-control"  type="password"  [ngModel]>
                        </div>
                        <div class="form-group">
                          <input  name="confirm_password" placeholder="confirm password" class="form-control"  type="password"  [ngModel]>
                        </div>
                      </div>
                      <div class="form-group">
                        <input name="submit" class="btn btn-lg btn-primary btn-block" value="submit" type="submit">
                      </div>
                    </form>
    
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          </div>
     
	</div>
</div>